<template>
  <div class="layout-default">
    <SiteHeader />
    <slot />
    <SiteFooter />
  </div>
</template>
